export default "__VITE_ASSET__Cyc0USX0__"